import { getZoneFromSite, siteNames } from '@seek/melways-sites';
import { Brand, Product } from '../../types.js';
export default {
    audience: 'https://seek/api/candidate',
    authDomain: 'login.staging.seek.com',
    clientDomain: 'ph.staging.jobstreet.com',
    clientId: '2tTMhcw83BVWLnWL1kwVoebQkvtO9sxu',
    environment: 'dev',
    redirectPath: '/oauth/callback/',
    realm: 'Username-Password-Authentication',
    brand: Brand.JOBSTREET,
    contactUs: {
        en: 'https://ph.jobstreet.com/contact-us/',
    },
    siteName: siteNames.candidate.jobstreet.ph,
    zone: getZoneFromSite(siteNames.candidate.jobstreet.ph),
    product: Product.SEEK,
};
//# sourceMappingURL=ph_staging_jobstreet_com.js.map